/**
 * 数据上报私有参数
 */

export const getUserReportParams = (params?: Record<string, any>) => ({
  ...params,
});
